// Helper function to get default cover image for tracks without cover_image_url
// Cycles through available Soundope logo variants based on track ID hash

import cover1 from '@/assets/default-art/0392F786-6048-414B-837E-CF20FD4EF5E2_1_201_a.jpeg';
import cover2 from '@/assets/default-art/10486AC2-0F05-4B08-B6CA-568751D4A2EB.png';
import cover3 from '@/assets/default-art/1C2EA0EA-C5BA-4C64-99B1-4D2ECAB7433F_1_201_a.jpeg';
import cover4 from '@/assets/default-art/239A1284-0542-424E-A377-7A95300CC26E_1_201_a.jpeg';
import cover5 from '@/assets/default-art/5EB5D950-8C7A-46EE-9C05-C15949516F42_1_201_a.jpeg';
import cover6 from '@/assets/default-art/68BED098-BB7B-4D84-A03E-C25699C09420_1_105_c.jpeg';
import cover7 from '@/assets/default-art/77982679-6AE9-4227-A20F-8224A35697CB_1_201_a.jpeg';
import cover8 from '@/assets/default-art/917F3057-F386-48D9-856E-DA397BC14A47.png';
import cover9 from '@/assets/default-art/A75DE4B7-A165-4BA2-9F6D-29708E761471.png';
import cover10 from '@/assets/default-art/E15CAA6C-2C39-46E9-BD45-AE13CDE05B5B.png';
import cover11 from '@/assets/default-art/E4548FC7-D6D0-4337-B963-2E79F1150538.png';

const DEFAULT_COVERS = [
  cover1,
  cover2,
  cover3,
  cover4,
  cover5,
  cover6,
  cover7,
  cover8,
  cover9,
  cover10,
  cover11,
];

/**
 * Check if a cover image URL is valid (not null, empty, or placeholder)
 * @param {string|null|undefined} url - The cover image URL to check
 * @returns {boolean} - True if URL is valid
 */
export function isValidCoverImage(url) {
  if (!url) return false;
  if (typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (trimmed === '') return false;
  // Check for common placeholder patterns
  if (trimmed.includes('placeholder') || trimmed.includes('default') || trimmed === 'null' || trimmed === 'undefined') {
    return false;
  }
  return true;
}

/**
 * Get a default cover image URL for a track based on its ID
 * This ensures variety by cycling through available logos based on track ID hash
 * @param {string} trackId - The track's unique ID
 * @returns {string} - URL to a default cover image
 */
export function getDefaultCoverImage(trackId) {
  if (!trackId) {
    return DEFAULT_COVERS[0];
  }
  
  // Simple hash function to convert track ID to a number
  let hash = 0;
  for (let i = 0; i < trackId.length; i++) {
    const char = trackId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Use absolute value and modulo to get index
  const index = Math.abs(hash) % DEFAULT_COVERS.length;
  return DEFAULT_COVERS[index];
}

/**
 * Get cover image URL with fallback to default
 * @param {string|null|undefined} coverImageUrl - The track's cover_image_url
 * @param {string} trackId - The track's unique ID
 * @returns {string} - Valid cover image URL
 */
export function getCoverImage(coverImageUrl, trackId) {
  if (isValidCoverImage(coverImageUrl)) {
    return coverImageUrl;
  }
  return getDefaultCoverImage(trackId);
}

